/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fleet_CoordinatesInputs */

const vi_fleet_coordinates = /** @type {(inputs: Fleet_CoordinatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tọa độ`)
};

/**

* @param {Fleet_CoordinatesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const fleet_coordinates = /** @type {((inputs?: Fleet_CoordinatesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fleet_CoordinatesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_fleet_coordinates(inputs)
});